import CallAction from '../components/Coaching/CallAction'
import { ContainerWrapper } from '../components/Container'
import Footer from '../components/Footer'
import Header from '../components/Header'
import LandingPageWrapper from '../components/HomePage/LandingPageWrapper'
import BenefitsSection from '../components/PremiumLists/BenefitsSection'
import HeroSection from '../components/PremiumLists/HeroSection'
import PricingSection from '../components/PremiumLists/PricingSection'
import Testimonials from '../components/PremiumLists/Testimonials'
import WhyChooseUs from '../components/PremiumLists/WhyChoose'
import ClientSuccess from '../components/SwitchToUs/ClientSuccess'
import { ProductAPI } from '../apis/server/ProductAPI'
import HomepageBookCallLeadModal from '../components/Modals/HomepageBookCallLeadModal'
import BookACallPremiumList from '../components/Buttons/Specials/BookACallPremiumList'

const PREMIUM_LISTS_MODAL_PROPS = {
    meetingTitle: 'Book a Premium List Call',
    formName: 'Premium Lead Lists Strategy Call',
}

export default function PremiumLeadLists({ data }) {
    return (
        <LandingPageWrapper>
            <Header metaTitle="Premium Lead Lists" meta={data?.yoast_head} />
            <HeroSection
                Modal={HomepageBookCallLeadModal}
                modalProps={PREMIUM_LISTS_MODAL_PROPS}
            />
            <PricingSection
                Modal={HomepageBookCallLeadModal}
                modalProps={PREMIUM_LISTS_MODAL_PROPS}
            />
            <BenefitsSection />
            <WhyChooseUs />
            <Testimonials />
            <ClientSuccess shouldHaveBg={false} />
            <ContainerWrapper>
                <CallAction
                    CallActionButton={(props) => (
                        <BookACallPremiumList
                            {...props}
                            Modal={HomepageBookCallLeadModal}
                            modalProps={PREMIUM_LISTS_MODAL_PROPS}
                        />
                    )}
                />
            </ContainerWrapper>
            <Footer />
        </LandingPageWrapper>
    )
}
export async function getStaticProps() {
    const { data: productData } = await ProductAPI.getProductsBySlug(
        'premium-lead-lists',
    )
    const data = productData ? productData[0] : {}

    return {
        props: { data: data },
        revalidate: 10, // In seconds
    }
}
